import script from "./ResetHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResetHeader.vue?vue&type=script&setup=true&lang=ts"

import "./ResetHeader.vue?vue&type=style&index=0&id=5adac9c1&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5adac9c1"]])

export default __exports__